import { PlayCircle as PlayCircle_kojaro } from './PlayCircle.kojaro';
import { PlayCircle as PlayCircle_zoomg } from './PlayCircle.zoomg';
import { PlayCircle as PlayCircle_zoomit } from './PlayCircle.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return PlayCircle_kojaro;

    case 'zoomg':
      return PlayCircle_zoomg;

    default:
      return PlayCircle_zoomit;
  }
};

export const PlayCircle = IconRenderer();
